module.exports = __webpack_public_path__ + "images/0dc0cfe07270545d4a84e9ad7b76004d.svg";